var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgInsights = function SvgInsights(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M10.028 9.572V3.595c0-.241.187-.445.428-.445a5.994 5.994 0 0 1 5.993 5.994c0 .24-.203.428-.444.428zm-7.278.856a6.42 6.42 0 0 1 5.539-6.36.405.405 0 0 1 .454.412v6.376l4.188 4.188c.179.179.166.473-.04.618a6.421 6.421 0 0 1-10.14-5.233m14.084.428c.25 0 .445.209.413.455a6.4 6.4 0 0 1-1.978 3.807.407.407 0 0 1-.567-.018l-4.246-4.244z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInsights);
export default ForwardRef;